import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@material-ui/core";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";
import React from "react";
import {Controller, useForm} from "react-hook-form";
import {CustomCheckbox} from "../../../../util";
import {DatePicker} from "@material-ui/pickers";
import {useLocation} from "react-router-dom";
import apiHelper from "../../../../util/ApiHelper";
import {toast} from "react-toastify";
import {useHistory} from "react-router";

const useStyles = makeStyles((theme) => ({
    innerBox: {
        background: "#ffffff",
        marginBottom: theme.spacing(4),
        "& *": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
    sectionBox: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    sectionTitle: {
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "15px",
        color: "#333333",
    },
    itemTitle: {
        fontWeight: "bold",
        fontSize: "12px",
        lineHeight: "14px",
        color: "#333333",
    },
    itemValue: {
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px",
        color: "#333333",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
            color: "grey !important"
        },
    },
    buttonGroup: {
        textAlign: "right",
        marginTop: "-20px",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    checkbox: {
        "& .MuiSvgIcon-root": {
            fontSize: "22px"
        }
    },
    formLabel: {
        width: "fit-content"
    },
    plGrid: {
        paddingLeft: "10px !important"
    },
    plGrid2: {
        paddingLeft: "20px !important"
    },
    table: {
        border: "1px solid grey",
        marginBottom: "10px"
    },
    mtGrid: {
        marginTop: "10px !important"
    },
    mbGrid: {
        marginBottom: "10px !important"
    }
}));

const defaultFormValues = {
    isExistingMember: false,
    plan: {
        id: 0,
        localizations: {
            en: {
                name: ""
            },
            tc: {
                name: ""
            }
        },
        price: "",
        status: ""
    },
    validFrom: "",
    expiryDate: "",
    totalAmount: "",
    ref: "",
    paymentStatus: "",
    gifts: null,
    sendReceipt: false,
    delivery: null,
    donation: null
};

function MemberRecordPage(props) {
    const history = useHistory();
    const location = useLocation();
    console.log('location', location);
    const classes = useStyles();
    const {match, disabled} = props;
    const {id} = match.params;
    const [defaultValue, setDefaultValue] = React.useState(defaultFormValues);

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
    });

    const onSubmit = async (value) => {
        try {
            const data = {
                validFrom: value.validFrom,
                expiryDate: value.expiryDate
            };
            console.log(data);
            const res = await apiHelper.hkiff.updateMemberRecordById(id, data);
            console.log(res);
            if (res.status === 200) {
                toast.dark("Record is updated.");
                history.goBack();
            }
        } catch (e) {
            console.log(e);
        }
    };

    React.useEffect(() => {
        if (location.state) {
            setDefaultValue(location.state);
            console.log('locationstate', location.state)
            reset(location.state);
        }
    }, [])

    console.log(defaultValue);

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Membership > Member Record Detail
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box className={classes.innerBox}>
                    {/* General Detail */}
                    <Box className={classes.sectionBox}>

                        <Grid container xs={12}
                              className={classes.plGrid}
                              direction="row" spacing={3}>
                            <Grid item xs={12}>
                                <Controller
                                    name="isExistingMember"
                                    control={control}
                                    defaultValue={defaultValue.isExistingMember}
                                    render={({
                                                 field: {
                                                     value,
                                                     onChange,
                                                     ...rest
                                                 },
                                             }) => {
                                        return (
                                            <FormControlLabel
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={value}
                                                        className={classes.checkbox}
                                                        {...rest}
                                                        disabled={true}
                                                    />
                                                }
                                                className={classes.formLabel}
                                                label="Is CineFan Member"
                                            />
                                        )
                                    }
                                    }
                                />
                            </Grid>
                        </Grid>


                        <Grid container xs={12}
                              direction="row"
                              className={classes.mtGrid}
                              spacing={3}>
                            <Grid container item xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1}
                                      xs={6}>
                                    <Grid
                                        className={classes.plGrid}>
                                        <Grid
                                            item>
                                            <Typography
                                                className={classes.itemTitle}>
                                                Plan Name
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                className={classes.itemValue}>
                                                {defaultValue.plan?.localizations?.en?.name || '-'}
                                                {defaultValue.isRenewPlan && ' (Renewal)'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container item xs={12}
                                      direction="row"
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid item>
                                            <Controller
                                                name="validFrom"
                                                control={control}
                                                render={({
                                                             field,
                                                             fieldState: {error}
                                                         }) => (
                                                    <DatePicker
                                                        fullWidth
                                                        variant="outlined"
                                                        inputVariant="outlined"
                                                        openTo="year"
                                                        margin="dense"
                                                        label="Valid From"
                                                        format="dd-MMM-yyyy"
                                                        className={classes.textInput}
                                                        {...field}
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid item>
                                            <Controller
                                                name="expiryDate"
                                                control={control}
                                                render={({
                                                             field,
                                                             fieldState: {error}
                                                         }) => (
                                                    <DatePicker
                                                        fullWidth
                                                        variant="outlined"
                                                        inputVariant="outlined"
                                                        openTo="year"
                                                        margin="dense"
                                                        label="Expiry Date"
                                                        format="dd-MMM-yyyy"
                                                        className={classes.textInput}
                                                        {...field}
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container item xs={12}
                                      direction="row"
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid item>
                                            <Controller
                                                name="totalAmount"
                                                control={control}
                                                render={({
                                                             field,
                                                             fieldState: {error}
                                                         }) => (
                                                    <TextField
                                                        label="Total Amount"
                                                        variant="outlined"
                                                        margin="dense"
                                                        type="number"
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 0,
                                                                step: 0.1
                                                            }
                                                        }}
                                                        className={classes.textInput}
                                                        fullWidth
                                                        {...field}
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                        disabled={true}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid container xs={12}
                                      direction="row"
                                      className={classes.mtGrid}
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid
                                            className={classes.plGrid2}>
                                            <Grid
                                                item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Payment
                                                    Ref
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemValue}>
                                                    {defaultValue.ref || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid
                                            className={classes.plGrid2}>
                                            <Grid
                                                item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Payment
                                                    Status
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemValue}>
                                                    {defaultValue.paymentStatus || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container item
                                          direction="column"
                                          className={classes.mbGrid}
                                          spacing={1}
                                          xs={12}>
                                        <Grid container
                                              className={classes.plGrid2}
                                              item
                                              direction="column"
                                              spacing={1}
                                              xs={6}>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Status
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Controller
                                                    control={control}
                                                    defaultValue={defaultValue?.plan?.status}
                                                    name="plan.status"
                                                    render={({
                                                                 field: {
                                                                     value,
                                                                     onChange,
                                                                     ...rest
                                                                 },
                                                                 fieldState,
                                                             }) => (
                                                        <ToggleButtonGroup
                                                            {...rest}
                                                            value={value}
                                                            exclusive
                                                            aria-label="Status"
                                                            className={classes.input}
                                                        >
                                                            <ToggleButton
                                                                value="ACTIVE"
                                                                disable={true}
                                                                aria-label="Active">
                                                                Active
                                                            </ToggleButton>
                                                            <ToggleButton
                                                                value="INACTIVE"
                                                                disable={true}
                                                                aria-label="Inactive">
                                                                Inactive
                                                            </ToggleButton>
                                                        </ToggleButtonGroup>
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider/>
                    {/* WELCOME GIFT Details */}
                    <Box className={classes.sectionBox}>
                        <Grid container xs={12}
                              direction="row"
                              spacing={3}>
                            <Grid container item xs={12}
                                  direction="row">
                                <Typography
                                    className={classes.sectionTitle}>
                                    Welcome Gift
                                </Typography>
                            </Grid>
                            <Grid container item xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1}
                                      xs={12}>
                                    <Grid item>
                                        <Typography
                                            className={classes.itemTitle}>
                                            List of Selected
                                            Welcome Gift
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item xs={12}
                                      direction="row"
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={12}>
                                        <TableContainer
                                            className={classes.table}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Name
                                                            of
                                                            Welcome
                                                            Gift</TableCell>
                                                        <TableCell>Quantity</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {defaultValue.gifts && defaultValue.gifts.map((item) => (
                                                        <TableRow>
                                                            <TableCell>{item.gift && item.gift.localizations && item.gift.localizations.en && item.gift.localizations.en.name || '-'}</TableCell>
                                                            <TableCell>{item.quantity}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>


                                <Grid container xs={12}
                                      className={classes.mtGrid}
                                      direction="row"
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid
                                            className={classes.plGrid2}>
                                            <Grid
                                                item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Pickup
                                                    Method
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemValue}>
                                                    {defaultValue.delivery && defaultValue.delivery.method || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid
                                            className={classes.plGrid2}>
                                            <Grid
                                                item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Code /
                                                    Address
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemValue}>
                                                    {defaultValue.delivery && defaultValue.delivery.address || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container xs={12}
                                      className={`${classes.mtGrid} ${classes.mbGrid}`}
                                      direction="row"
                                      spacing={3}>
                                    <Grid container item
                                          direction="column"
                                          spacing={1}
                                          xs={6}>
                                        <Grid
                                            className={classes.plGrid2}>
                                            <Grid
                                                item>
                                                <Typography
                                                    className={classes.itemTitle}>
                                                    Delivery
                                                    Fee
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    className={classes.itemValue}>
                                                    {defaultValue.delivery ? defaultValue.delivery.price : '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Box>
                    <Divider/>
                    {/* Donation Details */}
                    <Box className={classes.sectionBox}>
                        <Grid container xs={12}
                              direction="row"
                              spacing={3}>
                            <Grid container item xs={12}
                                  direction="row">
                                <Typography
                                    className={classes.sectionTitle}>
                                    Donation
                                </Typography>
                            </Grid>
                            <Grid container item xs={12}
                                  direction="row"
                                  spacing={3}>
                                <Grid container item
                                      direction="column"
                                      spacing={1}
                                      xs={6}>
                                    <Grid
                                        className={classes.plGrid}>
                                        <Grid
                                            item>
                                            <Typography
                                                className={classes.itemTitle}>
                                                Amount
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                className={classes.itemValue}>
                                                {defaultValue.donation ? defaultValue.donation.amount : '-'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container xs={12}
                              className={classes.plGrid}
                              direction="row" spacing={3}>
                            <Grid item xs={12}>
                                <Controller
                                    name="donation.sendReceipt"
                                    control={control}
                                    defaultValue={defaultValue.donation && defaultValue.donation.sendReceipt}
                                    render={({
                                                 field: {
                                                     value,
                                                     onChange,
                                                     ...rest
                                                 },
                                             }) => {
                                        return (
                                            <FormControlLabel
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={value}
                                                        className={classes.checkbox}
                                                        {...rest}
                                                        disabled={true}
                                                    />
                                                }
                                                className={classes.formLabel}
                                                label="Need Receipt"
                                            />
                                        )
                                    }
                                    }
                                />
                            </Grid>
                        </Grid>

                    </Box>
                </Box>
                {disabled || (
                    <div
                        className={classes.buttonGroup}>
                        <Button
                            type="submit"
                            variant="contained"
                            disableElevation
                            style={{
                                color: "white",
                                background: "#306F9D",
                                marginRight: "5px",
                                padding: "9px 16px",
                            }}
                        >
                            Update Record
                        </Button>
                    </div>
                )}
            </form>
        </Box>
    );
}

export default MemberRecordPage;
